// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentDetail-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 64px;
  backdrop-filter: blur(10px);
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem 1rem 0 1rem;
  overflow: hidden;
}

.contentDetail-card {
  background-color: #242424;
  color: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 800px;
  max-height: calc(100vh - 200px); /* viewport height - navbar - padding */
  overflow-y: auto;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  position: relative;
  /* margin-bottom: 2rem;
  margin-top: 4rem; */
}

.close-container {
  position: fixed;
  top: 1rem;
  right: 50%;
  transform: translateX(calc(400px - 3rem)); /* Half of max-width minus some padding */
  z-index: 10000;
  background: linear-gradient(to bottom, rgba(36, 36, 36, 1) 50%, rgba(36, 36, 36, 0));
  padding: 0.75rem;
  border-radius: 8px;
}

.close-container svg {
  color: #b3b3b3;
  transition: all 0.3s ease;
  cursor: pointer;
}

.close-container svg:hover {
  color: #ffffff;
  transform: scale(1.1);
}

.social-media-container {
  position: absolute;
  top: 0.75rem;
  left: 1rem;
  display: flex;
  gap: 0.75rem;
}

.social-icon {
  color: #b3b3b3;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 2rem;
}

.social-icon:hover {
  color: #3a86ff;
  transform: scale(1.1);
}

.contentDetail-card h2 {
  font-size: 1.8rem;
  margin: 2rem 0 0.5rem;
  font-weight: 700;
}

.media-runtime-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  justify-content: space-between;
}

.media-runtime-container h5 {
  font-size: 1rem;
  font-weight: 600;
  color: #3a86ff;
  margin: 0;
  margin-bottom: 1rem;
}

.media-runtime-container p {
  font-size: 0.9rem;
  color: #b3b3b3;
  margin: 0;
  margin-bottom: 1rem;
}

.ContentDetailPoster {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  margin: 0 auto 1rem auto; /* Center the poster */
  display: block; /* Ensures proper centering */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.contentDetail-card p {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0.8rem;
}

.contentDetail-card strong {
  color: #3a86ff;
  font-weight: 600;
}

.providers-section {
  margin-top: 1.5rem;
}

.providers-section h3 {
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  font-weight: 700;
}

.providers-section h4 {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.providers-section ul {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.providers-section li {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0.4rem 0.8rem;
  border-radius: 1rem;
  font-size: 0.9rem;
}

.providers-section li img {
  height: 2em;
  margin-right: 0.4em;
}

.provider-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 1rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}

.provider-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.provider-logo-container {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 0.4rem;
  transition: all 0.3s ease;
}

.provider-logo-container:hover {
  transform: scale(1.05);
}

.provider-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.type-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.type-label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #ffffff;
}

.price-info {
  font-size: 0.7rem;
  color: #b3b3b3;
}

.contentDetail-credits-container {
  margin-top: 1.5rem;
  margin-bottom: 2rem; /* Extra space at the bottom */
  text-align: center;
  color: #b3b3b3;
  font-size: 0.8rem;
}

.contentDetail-card > *:last-child {
  margin-bottom: 4rem;
}

.justwatch-logo {
  width: 80px;
  margin-top: 0.4rem;
}

/* Custom scrollbar styling */
.contentDetail-card::-webkit-scrollbar {
  width: 8px;
}

.contentDetail-card::-webkit-scrollbar-track {
  background: rgba(51, 51, 51, 0.5);
  border-radius: 4px;
}

.contentDetail-card::-webkit-scrollbar-thumb {
  background-color: rgba(102, 102, 102, 0.8);
  border-radius: 4px;
}

.contentDetail-card::-webkit-scrollbar-thumb:hover {
  background-color: rgba(136, 136, 136, 0.9);
}

/* Hide scrollbar on mobile but keep functionality */
@media (max-width: 767px) {
  .contentDetail-card {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }

  .contentDetail-card::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .close-container {
    right: 1rem;
    transform: none;
  }

  .close-container svg {
    color: #b3b3b3;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .close-container svg:hover {
    color: #ffffff;
    transform: scale(1.1);

  }
}

/* Desktop styles */
@media (min-width: 768px) {
  .contentDetail-container {
    padding: 2rem 2rem 0 2rem;
  }

  .contentDetail-card {
    padding: 2rem;
    max-height: calc(100vh - 64px - 4rem);
  }

  .contentDetail-card h2 {
    font-size: 2.2rem;
  }

  .media-runtime-container h5 {
    font-size: 1.2rem;
  }

  .media-runtime-container p {
    font-size: 1rem;
  }

  .contentDetail-card p {
    font-size: 1.1rem;
  }

  .providers-section h3 {
    font-size: 1.6rem;
  }

  .providers-section h4 {
    font-size: 1.4rem;
  }

  .provider-container {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .provider-logo-container {
    width: 80px;
    height: 80px;
  }

  /* Show scrollbar only on desktop */
  .contentDetail-card::-webkit-scrollbar {
    width: 8px;
  }

  .contentDetail-card::-webkit-scrollbar-track {
    background: rgba(51, 51, 51, 0.5);
    border-radius: 4px;
  }

  .contentDetail-card::-webkit-scrollbar-thumb {
    background-color: rgba(102, 102, 102, 0.8);
    border-radius: 4px;
  }

  .contentDetail-card::-webkit-scrollbar-thumb:hover {
    background-color: rgba(136, 136, 136, 0.9);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/ContentDetail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,+BAA+B,EAAE,uCAAuC;EACxE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB;qBACmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,yCAAyC,EAAE,yCAAyC;EACpF,cAAc;EACd,oFAAoF;EACpF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB,EAAE,sBAAsB;EAChD,cAAc,EAAE,6BAA6B;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,8BAA8B;EACnD,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oDAAoD;AACpD;EACE;IACE,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,gBAAgB;EAC5C;;EAEA;IACE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;;EAEvB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".contentDetail-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 64px;\n  backdrop-filter: blur(10px);\n  z-index: 9999;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 1rem 1rem 0 1rem;\n  overflow: hidden;\n}\n\n.contentDetail-card {\n  background-color: #242424;\n  color: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 800px;\n  max-height: calc(100vh - 200px); /* viewport height - navbar - padding */\n  overflow-y: auto;\n  padding: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  position: relative;\n  /* margin-bottom: 2rem;\n  margin-top: 4rem; */\n}\n\n.close-container {\n  position: fixed;\n  top: 1rem;\n  right: 50%;\n  transform: translateX(calc(400px - 3rem)); /* Half of max-width minus some padding */\n  z-index: 10000;\n  background: linear-gradient(to bottom, rgba(36, 36, 36, 1) 50%, rgba(36, 36, 36, 0));\n  padding: 0.75rem;\n  border-radius: 8px;\n}\n\n.close-container svg {\n  color: #b3b3b3;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.close-container svg:hover {\n  color: #ffffff;\n  transform: scale(1.1);\n}\n\n.social-media-container {\n  position: absolute;\n  top: 0.75rem;\n  left: 1rem;\n  display: flex;\n  gap: 0.75rem;\n}\n\n.social-icon {\n  color: #b3b3b3;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  font-size: 2rem;\n}\n\n.social-icon:hover {\n  color: #3a86ff;\n  transform: scale(1.1);\n}\n\n.contentDetail-card h2 {\n  font-size: 1.8rem;\n  margin: 2rem 0 0.5rem;\n  font-weight: 700;\n}\n\n.media-runtime-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  justify-content: space-between;\n}\n\n.media-runtime-container h5 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #3a86ff;\n  margin: 0;\n  margin-bottom: 1rem;\n}\n\n.media-runtime-container p {\n  font-size: 0.9rem;\n  color: #b3b3b3;\n  margin: 0;\n  margin-bottom: 1rem;\n}\n\n.ContentDetailPoster {\n  width: 100%;\n  max-width: 300px;\n  border-radius: 8px;\n  margin: 0 auto 1rem auto; /* Center the poster */\n  display: block; /* Ensures proper centering */\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.contentDetail-card p {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin-bottom: 0.8rem;\n}\n\n.contentDetail-card strong {\n  color: #3a86ff;\n  font-weight: 600;\n}\n\n.providers-section {\n  margin-top: 1.5rem;\n}\n\n.providers-section h3 {\n  font-size: 1.4rem;\n  margin-bottom: 0.8rem;\n  font-weight: 700;\n}\n\n.providers-section h4 {\n  font-size: 1.2rem;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n}\n\n.providers-section ul {\n  list-style-type: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n\n.providers-section li {\n  display: flex;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 0.4rem 0.8rem;\n  border-radius: 1rem;\n  font-size: 0.9rem;\n}\n\n.providers-section li img {\n  height: 2em;\n  margin-right: 0.4em;\n}\n\n.provider-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 1rem;\n  margin-top: 0.8rem;\n  margin-bottom: 0.8rem;\n}\n\n.provider-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.provider-logo-container {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 0.4rem;\n  transition: all 0.3s ease;\n}\n\n.provider-logo-container:hover {\n  transform: scale(1.05);\n}\n\n.provider-logo {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.type-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.type-label {\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: #ffffff;\n}\n\n.price-info {\n  font-size: 0.7rem;\n  color: #b3b3b3;\n}\n\n.contentDetail-credits-container {\n  margin-top: 1.5rem;\n  margin-bottom: 2rem; /* Extra space at the bottom */\n  text-align: center;\n  color: #b3b3b3;\n  font-size: 0.8rem;\n}\n\n.contentDetail-card > *:last-child {\n  margin-bottom: 4rem;\n}\n\n.justwatch-logo {\n  width: 80px;\n  margin-top: 0.4rem;\n}\n\n/* Custom scrollbar styling */\n.contentDetail-card::-webkit-scrollbar {\n  width: 8px;\n}\n\n.contentDetail-card::-webkit-scrollbar-track {\n  background: rgba(51, 51, 51, 0.5);\n  border-radius: 4px;\n}\n\n.contentDetail-card::-webkit-scrollbar-thumb {\n  background-color: rgba(102, 102, 102, 0.8);\n  border-radius: 4px;\n}\n\n.contentDetail-card::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(136, 136, 136, 0.9);\n}\n\n/* Hide scrollbar on mobile but keep functionality */\n@media (max-width: 767px) {\n  .contentDetail-card {\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n  }\n\n  .contentDetail-card::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera */\n  }\n\n  .close-container {\n    right: 1rem;\n    transform: none;\n  }\n\n  .close-container svg {\n    color: #b3b3b3;\n    transition: all 0.3s ease;\n    cursor: pointer;\n  }\n\n  .close-container svg:hover {\n    color: #ffffff;\n    transform: scale(1.1);\n\n  }\n}\n\n/* Desktop styles */\n@media (min-width: 768px) {\n  .contentDetail-container {\n    padding: 2rem 2rem 0 2rem;\n  }\n\n  .contentDetail-card {\n    padding: 2rem;\n    max-height: calc(100vh - 64px - 4rem);\n  }\n\n  .contentDetail-card h2 {\n    font-size: 2.2rem;\n  }\n\n  .media-runtime-container h5 {\n    font-size: 1.2rem;\n  }\n\n  .media-runtime-container p {\n    font-size: 1rem;\n  }\n\n  .contentDetail-card p {\n    font-size: 1.1rem;\n  }\n\n  .providers-section h3 {\n    font-size: 1.6rem;\n  }\n\n  .providers-section h4 {\n    font-size: 1.4rem;\n  }\n\n  .provider-container {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n\n  .provider-logo-container {\n    width: 80px;\n    height: 80px;\n  }\n\n  /* Show scrollbar only on desktop */\n  .contentDetail-card::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  .contentDetail-card::-webkit-scrollbar-track {\n    background: rgba(51, 51, 51, 0.5);\n    border-radius: 4px;\n  }\n\n  .contentDetail-card::-webkit-scrollbar-thumb {\n    background-color: rgba(102, 102, 102, 0.8);\n    border-radius: 4px;\n  }\n\n  .contentDetail-card::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(136, 136, 136, 0.9);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
